import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
  TextField,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from '@material-ui/core';
import isMobile from 'ismobilejs';

const styles = theme => ({
  table: {
    width: '100%',
    // minWidth: 600,
  },
  tableCell: {
    padding: '4px',
  },
  tableCellInside: {
    border: 0,
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    flexShrink: 0,
    color: '#FFFFFF',
  },
  expansionPanelSummary: {
    backgroundColor: '#799bfd',
    height: 40,
  },
  expansionPanelDetails: {
    padding: 0,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingLeft: 10,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: isMobile.phone ? 'calc(90%)' : '200px',
    borderBottom: 0,
  },
  tableHead: {
    textAlignLast: 'center',
  },
  tableCell: {
    padding: '0 5px 0 5px',
  },
});

class Summary extends React.Component {
  render() {
    const { summaries, classes } = this.props;
    return (
      <ExpansionPanel expanded>
        <ExpansionPanelSummary
          className={classes.expansionPanelSummary}
          style={{ minHeight: '40px', cursor: 'default' }}
        >
          <Typography className={classes.heading} color="inherit">
            Summary
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <form className={classes.container} noValidate autoComplete="off">
            <Table className={classes.table} aria-labelledby="ordersTable" id="summary">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classes.tableCell} />
                  <TableCell className={classes.tableCell}>Quantity</TableCell>
                  <TableCell className={classes.tableCell}>Total Cost (GST excluded)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody name="mainBody">
                {summaries.map(summaryItem => (
                  <TableRow hover tabIndex={-1} key={summaryItem.label}>
                    <TableCell
                      key={`${summaryItem.label}`}
                      className={classes.tableCell}
                      paddingNone
                    >
                      {summaryItem.label}
                    </TableCell>
                    {summaryItem.values.map(item => (
                      <TableCell
                        key={`${item.value}`}
                        className={classes.tableCell}
                        numeric
                        paddingNone
                        style={item.style}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </form>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

Summary.propTypes = {
  summaries: PropTypes.object,
};

export default withStyles(styles)(Summary);



// WEBPACK FOOTER //
// ./src/components/statements/Summary.js